import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';
import InputNumberFormat from 'components/common/InputNumberFormat';
import formatNumber from 'helpers/formatNumber';

const CreditUserForm = ({ form, onChange, walletItems }) => {
  const handleChange = (e, { name, value }) => {
    onChange(name, value);
  };

  const gtBankWallet = walletItems?.find(w =>
    w?.provider_name?.toLowerCase()?.includes('gt'),
  );

  const floatBalance = gtBankWallet?.float_balance;

  return (
    <div>
      <InputNumberFormat
        required
        name="amount"
        control={Input}
        label="Amount"
        type="number"
        placeholder="Amount..."
        onChange={handleChange}
        value={form.amount || ''}
      />
      {floatBalance != null && (
        <div className="credit-org-form__balance">
          <span className="credit-org-form__balance--label">
            Save Float Balance
          </span>
          <span className="credit-org-form__balance--value">
            {formatNumber(floatBalance)} Rwf
          </span>
        </div>
      )}
      <Form.TextArea
        required
        label="Description"
        placeholder="Type something..."
        name="description"
        className="textarea"
        onChange={handleChange}
        value={form.description || ''}
      />
    </div>
  );
};

CreditUserForm.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  walletItems: PropTypes.instanceOf(Array),
};

CreditUserForm.defaultProps = {
  walletItems: [],
};

export default CreditUserForm;
